/* import __COLOCATED_TEMPLATE__ from './mcp-template-list.hbs'; */
/* eslint-disable @intercom/intercom/no-bare-strings */
/* RESPONSIBLE TEAM: team-ml */

import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import type IntlService from 'embercom/services/intl';

interface Args {
  mcpActions: any[];
}

export default class McpTemplateList extends Component<Args> {
  @service declare intl: IntlService;

  @tracked showAddFromTemplateMcpServerModal = false;
  @tracked showAddCustomMcpServerModal = false;

  get templateList() {
    let templates = [
      {
        name: this.intl.t('workflow-connector.actions.mcp-actions.template-list.custom-mcp-title'),
        description: this.intl.t(
          'workflow-connector.actions.mcp-actions.template-list.custom-mcp-description',
        ),
        icon: 'mcp/custom-add',
        action: 'openAddCustomMcpServerModal',
        shouldDisplay: true,
      },
      {
        name: 'Stripe',
        description: this.intl.t(
          'workflow-connector.actions.mcp-actions.template-list.stripe-description',
        ),
        icon: 'mcp/stripe',
        action: 'openAddFromTemplateMcpServerModal',
        shouldDisplay: !this.args.mcpActions.some(
          (mcpAction) => mcpAction.mcp_server_name === 'Stripe',
        ),
      },
      {
        name: 'Shopify',
        description: this.intl.t(
          'workflow-connector.actions.mcp-actions.template-list.shopify-description',
        ),
        icon: 'mcp/shopify',
        action: 'openAddFromTemplateMcpServerModal',
        shouldDisplay: true,
      },
      {
        name: 'Status Page',
        description: this.intl.t(
          'workflow-connector.actions.mcp-actions.template-list.statuspage-description',
        ),
        icon: 'mcp/statuspage',
        action: 'openAddFromTemplateMcpServerModal',
        shouldDisplay: true,
      },
    ];
    return templates;
  }

  @action
  handleCardClick(actionName: string) {
    let actionFn = this[actionName as keyof this] as unknown as () => void;
    actionFn.call(this);
  }

  @action
  openAddFromTemplateMcpServerModal() {
    this.showAddFromTemplateMcpServerModal = true;
  }

  @action
  closeAddFromTemplateMcpServerModal() {
    this.showAddFromTemplateMcpServerModal = false;
  }

  @action
  openAddCustomMcpServerModal() {
    this.showAddCustomMcpServerModal = true;
  }

  @action
  closeAddCustomMcpServerModal() {
    this.showAddCustomMcpServerModal = false;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'WorkflowConnector::McpTemplateList': typeof McpTemplateList;
  }
}
